import React from "react";
import { FormGroup, FormLabel, FormControl } from "react-bootstrap";
import PropTypes from "prop-types";

const SelectInput = React.forwardRef((props, ref) => {
  return (
    <FormGroup>
      <FormLabel>{props.label}</FormLabel>
      <FormControl as="select" disabled={props.disabled} onChange={props.onChange} ref={ref}>
        <option value={null}>{props.default ? props.default : "Select..."}</option>
        {props.options
          ? props.options.map((option) =>
              option.toString() === props.default ? (
                ""
              ) : (
                <option key={option} value={option}>
                  {option.toString()}
                </option>
              )
            )
          : null}
      </FormControl>
    </FormGroup>
  );
});

SelectInput.propTypes = {
  default: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
};

export default SelectInput;
